import { FormRow } from 'framework/ui/layout';
import { DateInput, ClearAfterUnmountWrapper } from 'framework/form';
import { CURRENCY_TYPES } from '../core/constants';
import { CurrencyDropdown } from 'domain/shared/core/input';
import { InvoiceTotalInput } from '../core/invoice';

const { BYN, ...DROPDOWN_CURRENCY_TYPES } = CURRENCY_TYPES || {};

const OtherExpensesWasteRow = () => {
  return (
    <FormRow>
      <ClearAfterUnmountWrapper>
        <InvoiceTotalInput
          source="otherWasteDetails.cost.amount"
          currencySource="otherWasteDetails.cost.currency"
          label="Amount"
        />
      </ClearAfterUnmountWrapper>

      <ClearAfterUnmountWrapper>
        <CurrencyDropdown
          options={{ ...DROPDOWN_CURRENCY_TYPES, BYR: 'BYR' }}
          source="otherWasteDetails.cost.currency"
          label="Currency"
        />
      </ClearAfterUnmountWrapper>

      <ClearAfterUnmountWrapper>
        <DateInput isRequired source="otherWasteDetails.issueDate" label="Issue Date" />
      </ClearAfterUnmountWrapper>
    </FormRow>
  );
};

export default OtherExpensesWasteRow;
